<template>
  <v-menu offset-y :close-on-content-click="false">
    <template v-slot:activator="{ on, attrs }">
      <v-btn class="mr-2" dark color="blue" v-bind="attrs" v-on="on">
        Filter By
      </v-btn>
    </template>
    <v-list>
      <v-list-item>
        <v-container fluid>
          <div style="float:left;width:250px;margin-right:20px;">
            <v-expansion-panels v-model="panel">
              <v-expansion-panel>
                <v-expansion-panel-header>Meeting Country</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-select v-model="country" @change="filterBy()" :items="countriesFormatted" label="Country" dense hide-details outlined></v-select>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <v-spacer class="mt-5"></v-spacer>
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>Meeting State</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-select v-show="this.country !== ''" v-model="state" @change="filterBy()" :items="getStates(this.country)" item-text="name" item-value="isoCode" label="State" dense hide-details outlined></v-select>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <v-spacer class="mt-5"></v-spacer>
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>Meeting Types</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-select v-model="meetingType" @change="filterBy()" :items="codes" label="Meeting Type" dense hide-details outlined></v-select>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
          <div style="float:left;width:250px;margin-right:20px;">
            <!-- <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>Meeting ID</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-text-field outlined label="Meeting ID" v-model="meetingId" small hide-details dense @keydown.enter="filterBy()"></v-text-field>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <v-spacer class="mt-5"></v-spacer> -->
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>Runners</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <span style="font-size: 0.9375rem; margin-bottom: 12px; margin-left: 12px;">Please enter the runner number(s) separated by comma.</span>
                    <v-text-field outlined label="Runner Number(s)" v-model="runnersArray" small hide-details dense @keydown.enter="filterBy()"></v-text-field>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <v-spacer class="mt-5"></v-spacer>
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>Bet Backs</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-radio-group v-model="betBack" @change="filterBy()" dense hide-details class="pl-2" label="Is Bet Back?">
                      <v-radio
                        label="Yes"
                        :value="true"
                      ></v-radio>
                      <v-radio
                        label="No"
                        :value="false"
                      ></v-radio>
                      <v-radio
                        label="None"
                        value="none"
                      ></v-radio>
                    </v-radio-group>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </v-container>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import csc from 'country-state-city'
import countries from 'i18n-iso-countries'

export default {
  name: 'Filters',
  data () {
    return {
      panel: 0,
      meetingType: 'none',
      country: 'none',
      state: 'none',
      // meetingId: '',
      runnersArray: '',
      betBack: 'none'
    }
  },
  props: {
    clearAllFilters: Boolean
  },
  watch: {
    clearAllFilters () {
      if (this.clearAllFilters) {
        this.clearFilters()
      }
    }
  },
  computed: {
    ...mapState(['countryRaces']),
    ...mapGetters(['getClearFiltersBy']),
    countriesFormatted () {
      if (this.getClearFiltersBy) {
        this.clearFilters()
      }

      // eslint-disable-next-line global-require
      countries.registerLocale(require('i18n-iso-countries/langs/en.json'))
      const countryList = this.countryRaces.map((c) => ({
        value: c.trackCountry,
        text: countries.getName(`${c.trackCountry}`, 'en')
      }))
      const b = {
        value: 'none',
        text: 'None'
      }
      countryList.splice(countryList.length, 0, b)
      return [...new Set(countryList)]
    },
    codes () {
      return [
        {
          value: 'THOROUGHBRED',
          text: 'Thoroughbred'
        },
        {
          value: 'HARNESS',
          text: 'Harness'
        },
        {
          value: 'GREYHOUND',
          text: 'Greyhound'
        },
        {
          value: 'none',
          text: 'None'
        }
      ]
    }
  },
  methods: {
    ...mapActions(['fetchBetSummary', 'setExportFilters', 'setRestartPagination', 'setSelectedCountry', 'setSelectedState', 'clearMeetingType', 'setSelectedMeetingId', 'setSelectedRunnersArray', 'setSelectedBetBack']),
    clearFilters () {
      this.meetingType = 'none'
      this.country = 'none'
      this.state = 'none'
      // this.meetingId = ''
      this.runnersArray = ''
      this.betBack = 'none'
      this.setSelectedCountry(null)
      this.setSelectedState(null)
      this.clearMeetingType()
      // this.setSelectedMeetingId(null)
      this.setSelectedRunnersArray(null)
      this.setSelectedBetBack(null)
    },
    filterBy () {
      let runners = ''
      if (this.runnersArray !== '') {
        runners = this.runnersArray.replace(/ /g, '').split(',')
      }

      this.setRestartPagination({ value: true })

      this.setExportFilters({
        country: this.country,
        meetingType: this.meetingType,
        state: this.state,
        clearFilteredBets: true,
        runnersArray: runners,
        betBack: this.betBack
      })
      this.fetchBetSummary({
        medium: 'intoState',
        infoType: 'intoState',
        betType: 'intoState',
        source: 'intoState',
        betId: 'intoState',
        clientRef: 'intoState',
        raceNumber: 'intoState',
        runnerNumber: 'intoState',
        time: 'intoState',
        country: this.country,
        meetingType: this.meetingType,
        state: this.state,
        clearFilteredBets: true,
        // meetingId: this.meetingId,
        runnersArray: runners,
        betBack: this.betBack,
        sortFields: { sortBy: 'intoState', sortType: 0 },
        overrides: { pagination: { page: 1, limit: 100 }, filtered: true }
      })
    },
    getStates (countryOf) {
      const oldStates = countries.alpha3ToAlpha2(`${countryOf}`)
      const states = csc.getStatesOfCountry(oldStates)
      const b = {
        isoCode: 'none',
        name: 'None'
      }
      states.splice(states.length, 0, b)
      return states
    }
  }
}
</script>
